module.exports = __webpack_public_path__ + "img/kdlist.d1f04e7a.png";